<template>
  <div style="height: calc(100vh - 340px); width: 100%; border-radius:20px; overflow:hidden; margin-bottom:10px; min-height: 360px;">
    
    <l-map v-if="showMap" :zoom="zoom" :center="center" :options="mapOptions" @update:center="centerUpdate"
      @update:zoom="zoomUpdate">
      <l-tile-layer :url="url" :attribution="attribution" />

      <template v-for="(item, key) in items" >
        <l-marker v-if="item.shop && item.shop.lat && item.shop.lon" :lat-lng="setPosition(item.shop)" :key="item.shop.id">
          <l-popup>
            <div>
              <div class="text-x4-b m-b-2">{{ item.shop.name }}</div>
              <div>Время начала: <b>{{ item.started_at | dateTimeFormat }}</b></div>
              <div>Время конца: <b>{{ item.ended_at | dateTimeFormat }}</b></div>
              <div>
                Адрес: 
                <span v-if="item.shop.address_full"> 
                  {{ item.shop.address_full }} 
                </span> 
              </div>
              <div class="my-2 imgs-marker" v-if="item.media.length">
                <figure v-for="el in points[key].media" :key="el.id">
                  <a :href="el.path" target="_blank">
                    <img :src="el.path_small" :alt="el.name">
                  </a>
                </figure>
              </div>
              <button @click="innerClick(item.shop)" class="btn btn-sm btn-warning mt-3">Открыть</button>
            </div>
          </l-popup>
        </l-marker>
      </template>

      <!-- <template v-if="polyline.latlngs.length">
        <l-polyline :lat-lngs="polyline.latlngs" :color="polyline.color" />
      </template> -->

    </l-map>
  </div>
</template>
<script>

import { mapState } from 'vuex';
import { latLng, Icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LPolyline } from "vue2-leaflet";
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
import 'leaflet/dist/leaflet.css';
export default {
  computed: {
    ...mapState(["lastUpdate"]),
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LPolyline
  },
  props: {
    points:{
      default: []
    },
    defaultLat: {
      default: 41.311081
    },
    defaultLon: {
      default: 69.240562
    },
    params: {
      default: function () {
        return {};
      }
    },
    cardLink: {
      default: function () {
        return '';
      }
    },
    polyline: {
      default: function () {
        return {
          latlngs: [],
          color: "green"
        };
      }
    },
  },
  created() {
    this.init(1);
  },
  methods: {
    init(page = 1) {
      this.items = this.points.filter(e=>{
        if(e.shop)
        return e
      })
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    innerClick(item) {
      const element = `${this.cardLink}`;
      let query = Object.assign({}, this.$route.query);
      if (query[element] == item.id) {
        return false;
      }
      if (query[element]) {
        delete query[element];
      }
      query[element] = item.id;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
    setPosition(item) {
      try {
        return latLng(item.lat, item.lon)
      } catch (error) {
        return latLng(0, 0)
      }
    }
  },
  data() {
    return {
      items: [],
      zoom: 11,
      center: latLng(this.defaultLat ? this.defaultLat : 41.311081, this.defaultLon ? this.defaultLon : 69.240562),
      currentCenter: latLng(this.defaultLat ? this.defaultLat : 41.311081, this.defaultLon ? this.defaultLon : 69.240562),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '',
      currentZoom: 11.5,
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true
    };
  },
  watch: {
    params: {
      handler: function (val) {
        setTimeout(() => {
          this.init(1);
        }, 100);
      },
      deep: true,
    },
    lastUpdate(val) {
      if (val) {
        this.init(1);
      }
    },
  }
};
</script>
<style lang="scss">
.leaflet-control,
.leaflet-popup-close-button {
  opacity: 0;
}
</style>
